export const CONFIRM_RESET_CART_MESSAGE = 'You can only have items for 1 customer type (Medical or Recreational) in your cart at a time. Adding this product will remove all items currently in your cart. Would you like to proceed?';
export const ADULT_CAN_ONLY_BUY_REC_MESSAGE = 'Recreational customers cannot purchase Medical items. If you have a valid medical cannabis recommendation, you can update your customer type in Account settings.';
export const PRODUCT_OUT_OF_STOCK_MESSAGE = 'The products that you are trying to reorder are currently out of stock.';
export const SAME_SALES_CHANNEL_MESSAGE = 'You can only have items from the same sales channel. Adding this product will remove all items currently in your cart. Would you like to proceed?';
export const CONFIRM_RESET_CART = 'PROCEED';
export const CANCEL_RESET_CART = 'CANCEL';
export const RECREATIONAL_TEXT = 'RECREATIONAL';






// WEBPACK FOOTER //
// ./src/const/cart_const.js